import _styled, { default as _styled2 } from "styled-components";
import * as RadixRadioGroup from "@radix-ui/react-radio-group";
type Option = {
  label: string;
  value: string;
};
type Props = {
  options: Option[];
  value?: string;
  onChange?: (value: string) => void;
};
const Item = /*#__PURE__*/_styled(RadixRadioGroup.Item).withConfig({
  componentId: "sc-sf-91lgfk-0"
})`
  &[type="button"] {
    ${{
  "transitionProperty": "color, background-color, border-color, text-decoration-color, fill, stroke",
  "transitionDuration": "250ms",
  "transitionTimingFunction": "ease-in-out"
}}
    ${{
  "height": "3.2rem",
  "whiteSpace": "nowrap",
  "borderRadius": "2px",
  "paddingLeft": "var(--spacing-md)",
  "paddingRight": "var(--spacing-md)",
  "fontSize": "1.4rem",
  "lineHeight": "1.1",
  "letterSpacing": "0.028000000000000004rem",
  "fontWeight": "400",
  "--tw-text-opacity": "1",
  "color": "rgb(255 255 255 / var(--tw-text-opacity))",
  "outlineWidth": "0px",
  "@media (min-width: 1024px)": {
    "fontSize": "1.6rem",
    "lineHeight": "1.1",
    "letterSpacing": "0.016rem",
    "fontWeight": "400"
  }
}}
    ${{
  "backgroundColor": "var(--bg-secondary)"
}}
    ${{
  "&:hover": {
    "--tw-border-opacity": "1",
    "borderColor": "rgb(75 46 248 / var(--tw-border-opacity))",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(75 46 248 / var(--tw-bg-opacity))",
    "--tw-text-opacity": "1",
    "color": "rgb(255 255 255 / var(--tw-text-opacity))"
  }
}}
    ${{
  "&:focus-visible": {
    "--tw-ring-offset-shadow": "var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color)",
    "--tw-ring-shadow": "var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color)",
    "boxShadow": "var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000)",
    "--tw-ring-opacity": "1",
    "--tw-ring-color": "rgb(255 255 255 / var(--tw-ring-opacity))",
    "--tw-ring-offset-width": "2px",
    "--tw-ring-offset-color": "#4B2EF8"
  }
}}

    &[data-state="checked"] {
      ${{
  "--tw-border-opacity": "1",
  "borderColor": "rgb(75 46 248 / var(--tw-border-opacity))",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(75 46 248 / var(--tw-bg-opacity))",
  "--tw-text-opacity": "1",
  "color": "rgb(255 255 255 / var(--tw-text-opacity))"
}}
    }
  }
`;
export function MediaFilter(props: Props) {
  const {
    options,
    onChange,
    value
  } = props;
  return <_StyledRadixRadioGroupRoot className="hide-scrollbar" onValueChange={val => onChange?.(val)} value={value} orientation="horizontal" aria-label="Media filter">
      {options.map(({
      label,
      value
    }, idx) => <div key={idx}>
          <label>
            <Item value={value}>{label}</Item>
          </label>
        </div>)}
    </_StyledRadixRadioGroupRoot>;
}
var _StyledRadixRadioGroupRoot = /*#__PURE__*/_styled2(RadixRadioGroup.Root).withConfig({
  displayName: "media-filter___StyledRadixRadioGroupRoot",
  componentId: "sc-57q2bu-0"
})({
  "display": "flex",
  "flexWrap": "nowrap",
  "gap": "var(--spacing-sm)",
  "overflowX": "scroll",
  "backgroundColor": "var(--bg-secondary)",
  "padding": "var(--spacing-md)",
  "@media (min-width: 1024px)": {
    "gap": "0",
    "overflowX": "hidden",
    "backgroundColor": "var(--bg-secondary)",
    "padding": "var(--spacing-xs)"
  }
});